module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div  id=\"dialog\" title=\"Import\"  style=\"display: none;\">\r\n    <div class=\"file-select-step-1 step-template\" style=\"padding-bottom: 20px\">\r\n        <div style=\"padding: 10px 0\">\r\n            Select the file:\r\n        </div>\r\n        <div class=\"col-md-8\">\r\n            <input type=\"text\" name=\"file-name\" id=\"file-name\" readonly>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n            <input type=\"file\" name=\"file-select\" id=\"file-select\" class=\"inputfile\" accept=\".pa,.pf\">\r\n            <label id=\"file-asset-label\" for=\"file-select\" class=\"file-asset-import\">Browse</label>\r\n        </div>\r\n    </div>\r\n    <div class=\"file-select-step-2 step-template\" style=\"padding-bottom: 20px\">\r\n        <div style=\"padding: 10px 0\"> \r\n            ")
    ; __append(escapeFn(message))
    ; __append("\r\n        </div>\r\n        <div style=\"font-weight: bolder\">\r\n            ")
    ; __append(escapeFn(itemName))
    ; __append("\r\n        </div>\r\n        <div>\r\n            Dependencies: ")
    ; __append(dependencies)
    ; __append("\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}